import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const AdminProfile = () => {
  const [formData, setFormData] = useState({
    id: "", // Include this for update
    first_name: "",
    last_name: "",
    admin_email: "",
    password: "",
    phone: "",
  });

  const admin_id = localStorage.getItem("admin_id");

  useEffect(() => {
    const fetchAdminProfile = async () => {
      try {
        const response = await axios.get(`${baseurl}FetchAdminDataByIdAdmin/${admin_id}`);
        if (response.data.success && response.data.admin) {
          setFormData({
            id: response.data.admin.id,
            first_name: response.data.admin.first_name || "",
            last_name: response.data.admin.last_name || "",
            admin_email: response.data.admin.admin_email || "",
            password: "", // keep empty; do not show actual hash
            phone: response.data.admin.phone || "",
          });
        }
      } catch (error) {
        console.error("Error fetching admin profile:", error);
      }
    };

    fetchAdminProfile();
  }, [admin_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name.trim() || !formData.admin_email.trim()) {
      Swal.fire("Validation Error", "First name and email are required", "warning");
      return;
    }

    try {
      const response = await axios.post(`${baseurl}updateAdminProfile`, formData);
      if (response.data.success) {
        Swal.fire("Success", "Profile updated successfully", "success");
      } else {
        Swal.fire("Error", response.data.message || "Update failed", "error");
      }
    } catch (error) {
      console.error("❌ Error updating profile:", error);
      Swal.fire("Error", "Failed to update profile", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <h4 className="mb-3 text-start">Admin Profile</h4>

          <div className="crd1 mb-3">
            <form onSubmit={handleSubmit}>
              <div className="row mb-3 text-start">
                <div className="col-md-4">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="admin_email"
                    className="form-control"
                    value={formData.admin_email}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Password (leave blank to keep unchanged)</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    placeholder="********"
                    value={formData.password}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="text-start mt-3">
                <button type="submit" className="btn btn-primary">
                  Update Profile
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
